import { call, put, takeLatest, select } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { menuService, GetMenuResponse } from '../../services/menuService';
import {
  fetchMenuRequest,
  fetchMenuSuccess,
  fetchMenuFailure,
} from '../slices/menuSlice';

function* fetchMenuSaga(action: PayloadAction<{ restaurantId: string; type?: string }>): Generator<unknown, void, any> {
  try {
    const { restaurantId, type } = action.payload;
    
    // Validate restaurantId
    if (!restaurantId) {
      console.error('❌ Menu API validation failed: Restaurant ID missing');
      yield put(fetchMenuFailure('Restaurant ID is required'));
      return;
    }
    
    // Get the current API key and API base URL from the state
    const authState = yield select((state: any) => state.auth);
    const currentApiKey = authState.currentApiKey;
    const apiBaseUrl = authState.apiBaseUrl;
    
    if (!currentApiKey) {
      console.error('❌ Menu API validation failed: API Key missing');
      yield put(fetchMenuFailure('API Key not available'));
      return;
    }
    
    if (!apiBaseUrl) {
      console.error('❌ Menu API validation failed: API Base URL missing');
      yield put(fetchMenuFailure('API base URL not available'));
      return;
    }
    
    const response: GetMenuResponse = yield call(
      menuService.getMenu,
      apiBaseUrl,
      restaurantId,
      currentApiKey,
      type
    );
    yield put(fetchMenuSuccess(response.data));
  } catch (error) {
    yield put(fetchMenuFailure(error instanceof Error ? error.message : 'Failed to fetch menu'));
  }
}

export function* watchMenuSaga() {
  yield takeLatest(fetchMenuRequest.type, fetchMenuSaga);
}
